import React from 'react';
import { Link } from 'react-router-dom';
import SimpleHeader from '../components/SimpleHeader';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      <SimpleHeader />
      
      <main className="pt-24 pb-20 px-6">
        <div className="max-w-2xl mx-auto">
          <Card className="bg-white p-12 text-center">
            <XCircle className="w-20 h-20 text-[#C17855] mx-auto mb-6" />
            
            <h1 className="text-4xl font-bold text-[#2C1810] mb-4">
              Payment Cancelled
            </h1>
            
            <p className="text-[#5A5046] text-lg mb-8">
              Your payment was cancelled. No charges have been made to your account.
            </p>
            
            <div className="bg-[#EBE6D8] p-6 rounded-lg mb-8">
              <p className="text-[#2C1810] mb-4">
                Changed your mind? The SpendLess Guide is still available.
              </p>
              <p className="text-[#5A5046] text-sm">
                <span className="font-bold text-[#C17855]">🚀 Launch Special:</span> Still just $9.99 for the first 100 buyers!
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/products/guide">
                <Button className="bg-[#C17855] hover:bg-[#B06745] text-white px-8 py-3 rounded-lg">
                  Try Again - Get the Guide
                </Button>
              </Link>
              <Link to="/">
                <Button variant="outline" className="border-2 border-[#6B7A5C] text-[#6B7A5C] hover:bg-[#6B7A5C] hover:text-white px-8 py-3 rounded-lg">
                  Back to Home
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PaymentCancelPage;